import type { ReactNode } from 'react'
import React from 'react'
import * as S from './Divider.styled'

export const Divider = ({
  label,
  marginTop,
  marginBottom,
}: {
  label?: ReactNode
  marginTop?: number
  marginBottom?: number
}) => {
  return (
    <S.Container $marginTop={marginTop} $marginBottom={marginBottom}>
      <S.Divider />
      {label && <S.Label>{label}</S.Label>}
      <S.Divider />
    </S.Container>
  )
}
